import { createApiSlice } from "@common";
import { CRUD_CAMPAIGN_TYPE, CRUD_CAMPAIGN_TYPE_BY_ID } from "@routes";

const apiConfig = [
  {
    name: "addCampaignType",
    method: "post",
    url: CRUD_CAMPAIGN_TYPE,
    stateKey: "message",
  },
  {
    name: "getCampaignTypeById",
    method: "get",
    url: CRUD_CAMPAIGN_TYPE_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateCampaignType",
    method: "put",
    url: CRUD_CAMPAIGN_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteCampaignType",
    method: "delete",
    url: CRUD_CAMPAIGN_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "campaignType",
  apiConfig,
  customReducers);
const campaignTypeSlice = slice;

export default campaignTypeSlice.reducer;

export const {
  addCampaignType,
  getCampaignTypeById,
  updateCampaignType,
  deleteCampaignType,
} = thunks;

export const { rowSelect } = actions;
